import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/Login.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/',
      component: () => import('@/components/AppLayout.vue'),
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          name: 'Dashboard',
          component: () => import('@/views/Dashboard.vue')
        },
        {
          path: '/products',
          name: 'Products',
          component: () => import('@/views/Products.vue')
        },
        {
          path: '/categories',
          name: 'Categories',
          component: () => import('@/views/Categories.vue')
        },
        {
          path: '/orders',
          name: 'Orders',
          component: () => import('@/views/Orders.vue')
        },
        {
          path: '/news',
          name: 'News',
          component: () => import('@/views/News.vue')
        },
        {
          path: '/articles',
          name: 'Articles',
          component: () => import('@/views/Articles.vue')
        },
        {
          path: '/cases',
          name: 'Cases',
          component: () => import('@/views/Cases.vue')
        },
        {
          path: '/settings',
          name: 'Settings',
          component: () => import('@/views/Settings.vue')
        }
      ]
    }
  ]
})

// Navigation guard to check authentication
router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()
  
  // Check if route requires authentication
  if (to.meta.requiresAuth !== false) {
    // Check if user is authenticated
    if (!authStore.isAuthenticated) {
      // Try to check auth (this will handle token refresh if needed)
      const isAuth = await authStore.checkAuth()
      if (!isAuth) {
        // Not authenticated, redirect to login
        next('/login')
        return
      }
    }
  } else if (to.name === 'Login' && authStore.isAuthenticated) {
    // Already logged in, redirect to dashboard
    next('/')
    return
  }
  
  next()
})

export default router
